module.exports = __webpack_public_path__ + "assets/img/263f-kz.svg";